import styled from "styled-components";

export const Container = styled.div`
  h4 {
    padding: 0 0 10px 10px;
    font-size: 24px;
  }
  h5 {
    font-size: 16px;
    padding: 0 0 10px 0;
  }
  padding: 112px 20px 0 20px;
  width: 100%;
  margin: 0 auto;
  .background-pool {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    min-width: 1200px;
    z-index: -1;
  }

  .pool-content {
    padding-bottom: 90px;
    display: flex;
    width: 100%;
    gap: 20px;
    flex: wrap;
    &__swap {
      width: 40%;
    }
    &__pools {
      width: 60%;
      height: unset;
    }
  }
  .pool-card {
    padding: 24px;
    background: #1b1e29;
    border-radius: 20px;
  }
  .coin-input {
    background: #232734;
  }
  .noLiquidityImage {
    max-width: 286px;
    width: 80%;
    filter: grayscale(1);
  }
  .weight-600 {
    font-weight: 600;
  }
  .pageHeading {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 16px;
  }
  .jss287 {
    text-align: center;
  }
  .liquidityText {
    color: #696c80;
    font-size: 14px;
    small {
      font-size: 14px !important;
    }
  }
  .liquidityText small {
    color: #448aff;
    cursor: pointer;
  }
  @media screen and (max-width: 700px) {
    .pool-content {
      flex: wrap !important;
      flex-direction: column !important;
      &__swap {
        width: 100%;
      }
      &__pools {
        width: 100%;
      }
    }
  }
`;
